import React from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import MetricCard from "./MetricCard";
import TrendCard from "./TrendCard";

import {
  cancellationData,
  cancellationOptions,
  engagementData,
  engagementOptions,
  peakTimesData,
  peakTimesOptions,
  popularOffersData,
  popularOffersOptions,
} from "./chartData";
import TablePanel from "./ListPanel";

// Mock Data Examples
const signups = [
  {
    name: "John Doe",
    date: "2025-07-08",
    phone: "+971 50 123 4567",
    membership: "Solo",
  },
  {
    name: "Jane Smith",
    date: "2025-07-07",
    phone: "+971 50 765 4321",
    membership: "Duo",
  },
];

const logins = [
  {
    user: "Harpreet",
    phone: "+971 50 000 1111",
    membership: "Solo",
    status: "Paid",
    loginStatus: "Online",
    logintime: "12:00 PM, 22-06-2025",
  },
  {
    user: "Priya",
    phone: "+971 50 222 3333",
    membership: "Duo",
    status: "Free",
    loginStatus: "Online",
    logintime: "11:55 PM, 22-06-2025",
  },
];
const bookings = [
  {
    id: "#00001",
    offer: "The Residence Tunis",
    time: "4th-June-2025 | 8:00PM",
    category: "Dining",
    client: "John",
  },
  {
    id: "#00002",
    offer: "The Residence Tunis",
    time: "4th-June-2025 | 8:00PM",
    category: "Event",
    client: "John",
  },
  {
    id: "#00003",
    offer: "The Residence Tunis",
    time: "4th-June-2025 | 8:00PM",
    category: "Event",
    client: "John",
  },
  {
    id: "#00004",
    offer: "The Residence Tunis",
    time: "4th-June-2025 | 8:00PM",
    category: "Event",
    client: "John",
  },
  {
    id: "#00005",
    offer: "The Residence Tunis",
    time: "4th-June-2025 | 8:00PM",
    category: "Dining",
    client: "John",
  },
];
const cancellations = [
  {
    id: "#00001",
    name: "John Doe",
    reason: "Lorem ipsum dolor sit amet.",
    time: "4th-June-2025 | 8:00PM",
    cancelledAt: "5th-June-2025 | 10:30AM",
    category: "Dining",
  },
  {
    id: "#00002",
    name: "Jane Smith",
    reason: "Schedule conflict with event.",
    time: "4th-June-2025 | 8:00PM",
    cancelledAt: "5th-June-2025 | 11:00AM",
    category: "Event",
  },
  {
    id: "#00003",
    name: "Mike Johnson",
    reason: "Change of plans.",
    time: "4th-June-2025 | 8:00PM",
    cancelledAt: "5th-June-2025 | 9:00AM",
    category: "Dining",
  },
];

const trials = [
  {
    name: "Ravi",
    endsOn: "2025-07-13",
    membershipType: "Single",
    membershipStatus: "Trial",
  },
  {
    name: "Neha",
    endsOn: "2025-07-15",
    membershipType: "Duo",
    membershipStatus: "Complementary",
  },
];

const renewals = [
  { name: "Aman", subscriptionName: "Single Membership", date: "2025-07-12" },
];

const Dashboard = () => {
  const navigate = useNavigate();
  const goToRevenuePage = () => navigate("/revenue-analytics");
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>
      {/* Metrics Section */}
      <h2 className="subTitle">Key Performance Indicators</h2>
      <div className="stats_boxes gap_m">
        <MetricCard
          title="Total Active Members(Solo)"
          value="1,240"
          subtext="↑ 5% from last month"
          onClick={goToRevenuePage}
        />
        <MetricCard
          title="Total Active Members(Duo)"
          value="1,240"
          subtext="↑ 5% from last month"
          onClick={goToRevenuePage}
        />
        <MetricCard
          title="Monthly Revenue(Bookings)"
          value="AED 12,450"
          subtext="Last Month: AED 15,000"
          onClick={goToRevenuePage}
        />
        <MetricCard
          title="Monthly Revenue(Subscriptions)"
          value="AED 12,450"
          subtext="Last Month: AED 15,000"
          onClick={goToRevenuePage}
        />

        <MetricCard
          title="Trial Conversions"
          value="18%"
          subtext="This month"
          onClick={goToRevenuePage}
        />
      </div>

      {/* Today's Activity */}
      <h2 className="subTitle">Today's Activity</h2>
      <div className="grid_sc gap_m">
        <TablePanel
          title="New Signups (Last 30 Days)"
          columns={[
            { label: "Name", key: "name" },
            { label: "Phone", key: "phone" },
            { label: "Membership Type", key: "membership" },
            { label: "Date", key: "date" },
          ]}
          data={signups}
        />

        <TablePanel
          title="Top Five Members"
          columns={[
            { label: "User", key: "user" },

            { label: "Membership Type", key: "membership" },
            { label: "Membership Status", key: "status" },
            { label: "Login Status", key: "loginStatus" },
            { label: "Last Login", key: "logintime" },
          ]}
          data={logins}
        />
        <TablePanel
          title="Active Members"
          columns={[
            { label: "User", key: "user" },

            { label: "Membership Type", key: "membership" },
            { label: "Membership Status", key: "status" },
            { label: "Login Status", key: "loginStatus" },
            { label: "Last Login", key: "logintime" },
          ]}
          data={logins}
        />

        <TablePanel
          title="Bookings Made Today"
          columns={[
            { label: "Offer Name", key: "offer" },
            { label: "Booking Time", key: "time" },
            { label: "Client Name", key: "client" },
            { label: "Category", key: "category" },
          ]}
          data={bookings}
          viewMore
          renderCell={(key, value, row) => {
            if (key === "offer") {
              return (
                <span
                  style={{
                    color: "#BC8F4B",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => navigate("/manage-offer/preview-offer-detail")}
                >
                  {value}
                </span>
              );
            }
            return value;
          }}
        />
        <TablePanel
          title="Cancellations Today"
          columns={[
            { label: "Booking ID", key: "id" },
            { label: "Member Name", key: "name" },
            { label: "Booking Time", key: "time" },
            { label: "Cancellation Time", key: "cancelledAt" },
            { label: "Category", key: "category" },
          ]}
          data={cancellations}
          viewMore
        />

        <TablePanel
          title="Expiring Trials"
          columns={[
            { label: "Name", key: "name" },
            { label: "Membership Type", key: "membershipType" },
            { label: "Membership Status", key: "membershipStatus" },
            { label: "Ends On", key: "endsOn" },
          ]}
          data={trials}
        />

        <TablePanel
          title="Upcoming Renewals"
          columns={[
            { label: "Name", key: "name" },
            { label: "Subscription Name", key: "subscriptionName" },
            { label: "Renewal Date", key: "date" },
          ]}
          data={renewals}
        />
      </div>

      {/* Alerts */}
      {/* <h2 className="subTitle">Alerts & Action Items</h2>
      <Grid container spacing={3} mb={5}>
        <Grid item xs={12} md={4}>
          <AlertCard title="Payment Failures" items={['Mark - failed 10 July']} />
        </Grid>
        <Grid item xs={12} md={4}>
          <AlertCard title="Inactive Members" items={['Alex - no login for 45 days']} />
        </Grid>
        <Grid item xs={12} md={4}>
          <AlertCard title="System Issues" items={['API timeout on bookings']} />
        </Grid>
      </Grid> */}

      {/* Trends */}
      <h2 className="subTitle">Weekly Trends</h2>
      <div className="grid_sc gap_m">
        <TrendCard
          title="Most Popular Offers"
          chartType="bar"
          chartData={popularOffersData}
          chartOptions={popularOffersOptions}
          timeFilters
        />
        <TrendCard
          title="Booking Peak Times"
          chartType="bar"
          chartData={peakTimesData}
          chartOptions={peakTimesOptions}
        />
        <TrendCard
          title="Member Engagement"
          chartType="bar"
          chartData={engagementData}
          chartOptions={engagementOptions}
        />
        <TrendCard
          title="Cancellation Patterns"
          chartType="bar"
          chartData={cancellationData}
          chartOptions={cancellationOptions}
        />
      </div>
    </MainContainer>
  );
};

export default Dashboard;
